import { Component, inject } from '@angular/core';
import { AuthSessionService } from '../../auth-session.service';

@Component({
  imports: [],
  selector: 'app-home',
  styleUrl: './home.scss',
  templateUrl: './home.html',
})
export class Home {
  readonly version = inject(AuthSessionService).paxVersion;
}
